<!-- 机器人输入联想功能 -->
<template>
  <!-- 这里最外层对输入内容进行判断。防止在网络请求过程中，用户点击了某项数据，而后网络请求成功后又将autocomplete渲染出来的bug -->
  <div v-if="inputContent" class="msg-auto-complete">
    <ul>
      <li v-for="(item,index) in list" :key="index" @click="onClickMsg(item)">
        <span class="text"><i class="icon-q"></i>{{item.question}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable max-len */
// import debounceMaker from '@/utils/debounce';
import { debounce } from '@tencent/qd-lib';
import DOMAIN from '@/imsdk/domain';
const domain = DOMAIN.getSDKDomain();
export default {
  props: {
    config: {
      default() {
        return {};
      },
    },
    inputContent: {
      default: '',
    },
  },

  computed: {
  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    inputContent(val) {
      this.inputChange(val);
    },
  },
  mounted() {
  },
  created() {

  },
  methods: {
    inputChange: debounce(function (val) {
      this.onChatInputChange(val);
    }, 300),

    onChatInputChange(inputValue) {
      if (inputValue.trim().length === 0) {
        this.list = [];
        return;
      }
      const queryData = {
        inner_appid: 10002,
        kfuin: this.config.kfuin,
        type: 2,
        index: 1,
        count: 3,
        keyword: inputValue,
        robotId: this.config.robotId,
        contactId: +new Date(),
        channel: 5,
      };
      const routeKey = process.env.BRANCH_ENV === 'oa' ? 'innerapi' : 'olapi';
      this.$ajax.get(`${domain.zhiwen}/${routeKey}/robot/complete-words`, { params: queryData }).then((res) => {
        const list  = (res.data.data && res.data.data.records) ? res.data.data.records : [];
        console.log(res, list);
        list.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.question = this.html2text(item.question);
        });
        this.list = list;
      })
        .catch(() => {

        });
    },
    html2text(html) {
      return html.replace(/<[^>]+>/ig, '');
    },
    onClickMsg(item) {
      this.list = [];
      this.$emit('onSelected', item);
    },
  },
};
</script>

<style lang="less" scoped>
.msg-auto-complete{
    width: 100%;
    background-color: hsla(0,0%,98%,.97);
    position: absolute;
    bottom: 0;

    ul{
      list-style-type: none;
      padding: 0;
      margin: 0;

      li{
        cursor: pointer;
        vertical-align: top;
        width: 100%;
        padding: 6px 15px;
        box-sizing: border-box;
        font-size: 14px;
        &:hover {
            background-color: rgba(237,239,242,.97);
            .icon-q {
                // eslint-disable-next-line max-len
                background: ~'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0zLjMzMyAwSDBsNC42NjcgOEg4eiIgZmlsbD0iIzAwNjdFRCIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+)';
            }
        }

        .text{
          line-height: 22px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        .icon-q {
            display: inline-block;
            width: 8px;
            height: 8px;
            margin-right: 5px;
            // eslint-disable-next-line max-len
            background: ~'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik00LjY2NyAwSDhMMy4zMzMgOEgweiIgZmlsbD0iI0E4QUJCMyIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+)';
        }
      }

    }
}
</style>
